import { styled } from 'styled-components'

import { FireButton } from '@nx/fire/button'

export const StyledHowToBuyLink = styled(FireButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`
